import React from 'react';


export default function BaseDataGlance(props) {

    let forwardButton;

    if (props.showForwardButton) {
        forwardButton = <i className='icons8-forward-arrow glance-link-icon' />
    }

    return (
        <>
            <div className='glance-holder col-6  col-md-3 glance-body'>
                <div className={'panel panel-default glance glance-1x1 glance-fixed glance-link ' + props.cssContentClass}>
                    <div className={'panel-heading ' + props.cssHeadingClass}>
                        <div className='edge edge-left'>
                            <i className={props.cssIconClass} aria-hidden='true' />
                        </div>
                        <div style={{ width: '80%' }}>
                            <h3 className='panel-title'>{props.Heading}</h3>
                        </div>
                        <div className='edge edge-right'>
                        </div>
                    </div>
                    <div className='panel-body'>
                        <h4>{props.DataPoint1}</h4>
                        <h4>
                            <div dangerouslySetInnerHTML={{ __html: props.DataPoint2 }} />
                        </h4>
                        <h5><div dangerouslySetInnerHTML={{ __html: props.DataPoint3 }} /></h5>
                        {forwardButton}

                    </div>
                </div>
            </div>
        </>
    );

}